const translations = {
  email: 'Email',
  password: 'Senha',
  submit: 'Logar',
  welcome: 'Boas-vindas à Btime!',
  ssoLogin: 'Login com SSO',
  ssoLoginRedirectMessage: 'Em instantes você será redirecionado para a tela inicial.',
  loginWithGoogle: 'Entrar com Google',
  'createPasswordModal.title': 'Para continuar crie uma nova senha!',
  'createPasswordModal.subtitle': 'Confira as dicas para criar uma senha segura!',
  'createPasswordModal.useFieldsBelow': 'Utilize os campos a baixo',
  'createPasswordModal.newPassword': 'Nova Senha',
  'createPasswordModal.repeatPassword': 'Repita a Senha',
  'createPasswordModal.createAndContinue': 'Criar e continuar!',
  'createPasswordModal.checkFieldsBelow': 'Confira os campos abaixo!',
  'createPasswordModal.tryAgain': 'Tente novamente',
  'passwordValidations.min8Characters': 'Digite no mínimo 8 caracteres',
  'passwordValidations.minOneLetter': 'Utilize no mínimo uma letra',
  'passwordValidations.minOneNumber': 'Utilize no mínimo um número',
  'passwordValidations.passwordsMustMatch': 'As senhas digitadas devem ser iguais',
  'passwordValidations.recommendationUppercase': 'Recomendação: Utilize uma letra maiúscula',
  'passwordValidations.recommendationSpecialChars': 'Recomendação: Utilize caracteres especiais, ex.: @$%&!',
  'newPasswordForm.resettingPassword': 'Redefinindo senha!',
  'newPasswordForm.confirmPassword': 'Confirmar senha',
  'newPasswordForm.passwordsDoNotMatch': 'As senhas digitadas não conferem!',
  'newPasswordForm.enterPasswordAndConfirmation': 'Digite a senha e a confirmação para continuar!',
  'newPasswordForm.changePassword': 'Alterar senha',
  'newPasswordForm.passwordSetSuccess': 'Senha definida com sucesso',
  'newPasswordForm.passwordSetDescription':
    'Se a solicitação foi feita pelo celular, abra o aplicativo e logue com a nova senha.',
  'newPasswordForm.linkNoLongerValid': 'Parece que esse link não é mais válido',
  'newPasswordForm.requestNewPasswordChange': 'Tente solicitar uma nova mudança de senha',
  'newPasswordForm.passwordNotUpdated': 'Senha não atualizada',
  'forgotPasswordForm.forgotPassword': 'Esqueceu a senha?',
  'forgotPasswordForm.requestNewPassword': 'Pedir nova senha',
  'forgotPasswordForm.requestCompleted': 'Solicitação concluída',
  'forgotPasswordForm.emailBeingSent': 'Um email está sendo enviado para você para redefinir sua senha.',
  'forgotPasswordForm.tryAgain': 'Tente novamente',
  'authFromAdmin.title': 'Login a partir do Admin',
  'authFromAdmin.subtitle':
    'Em instantes você será redirecionado para a tela inicial. Se não acontecer, faça o processo novamente pelo Admin.',
  'loginTemplate.platformTitle': 'Plataforma de Gestão Operacional',
  'loginTemplate.platformDescription':
    'A Btime é uma plataforma SaaS de gestão operacional que automatiza os fluxos, padroniza processos e aumenta a produtividade e eficiência de equipes internas ou externas',
  'viewSwitcher.wantToLogin': 'Deseja logar?',
  'viewSwitcher.clickHere': 'Clique aqui'
}

export default translations
